/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, TouchableOpacity } from 'react-native';
import { ChipWrapRow } from '../../shared/ui/ChipWrapRow';
import { operationalFilterStyles } from '../../shared/filters/operationalFilters.styles';
import { spacing } from '../../shared/theme/spacing';

export type ExpenseFormChipOption<T extends string> = {
  id: T;
  label: string;
  disabled?: boolean;
};

type Props<T extends string> = {
  options: ExpenseFormChipOption<T>[];
  value: T | null;
  onChange: (value: T) => void;
  disabled?: boolean;
  testIDPrefix?: string;
};

export function ExpenseFormChipRow<T extends string>({
  options,
  value,
  onChange,
  disabled = false,
  testIDPrefix,
}: Props<T>) {
  return (
    <ChipWrapRow gap={spacing.xs}>
      {options.map((option) => {
        const selected = value === option.id;
        const chipDisabled = disabled || option.disabled;
        return (
          <TouchableOpacity
            key={option.id}
            accessibilityRole="button"
            testID={testIDPrefix ? `${testIDPrefix}.${option.id}` : undefined}
            style={[
              operationalFilterStyles.chip,
              // Tap target ≥44px (el chip genérico queda en ~35px solo con padding).
              { minHeight: 44, justifyContent: 'center' },
              selected && operationalFilterStyles.chipActive,
              chipDisabled && !selected && operationalFilterStyles.chipDisabled,
            ]}
            onPress={() => {
              if (chipDisabled) return;
              onChange(option.id);
            }}
            disabled={chipDisabled}
            accessibilityState={{ disabled: chipDisabled, selected }}
          >
            <Text
              style={[
                operationalFilterStyles.chipText,
                selected && operationalFilterStyles.chipTextActive,
                chipDisabled && !selected && styles.chipTextDisabled,
              ]}
              numberOfLines={2}
            >
              {option.label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </ChipWrapRow>
  );
}

const styles = {
  chipTextDisabled: {
    opacity: 0.55,
  },
} as const;
